import { type UseQueryResult, useQuery } from 'react-query';

import {
  TradeOrderSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_TradeOrder_OrderView,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetTradeOrderTransactionById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_TradeOrder_OrderView | undefined,
  unknown
> => {
  const tradeOrderTransactionById = useQuery(['tradeOrderTransactionDetails', id], async () => {
    if (id) {
      return await handleRequest(
        TradeOrderSharedService.getApiAwardSettlementApiAppTradeOrderTradeOrderByTransactionId(id)
      );
    }
  });

  return tradeOrderTransactionById;
};

export default useGetTradeOrderTransactionById;
